<template>
  <ul class="tab-links" role="tablist">
    <li
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{
        'tab-links__item': true,
        'tab-links__item--active': activeTab.id === tab.id,
        'tab-links__item--disabled': tab.disabled,
      }"
      role="presentation"
    >
      <router-link class="tab-links__link" :to="tab.url" :id="`tab_${index}`">
        {{ tab.label }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import { useTabs } from '@/composables/useTabs.ts'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'tabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const currentRoute = useRoute()
    const { getActiveTab } = useTabs(props.tabs, currentRoute)

    const activeTab = computed(() => getActiveTab())
    const currentTab = computed(() => currentRoute.params.tab)

    return {
      activeTab,
    }
  },
}
</script>

<style lang="scss">
.tab-links {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: $spacer05 0 $spacer10;
  padding: 0;
  border-bottom: $spacer025 solid $community;

  @media (min-width: $bp-md) {
    margin-bottom: $spacer20;
  }

  &__item {
    margin: 0 $spacer025;

    @media (min-width: $bp-xs) {
      margin: 0 $spacer025;
    }

    @media (min-width: $bp-md) {
      margin: 0 $spacer05;
    }

    &--disabled {
      display: none;
    }
  }

  &__link {
    border-bottom: $tabs-border-width solid $tabs-border-inactive;
    display: block;
    transition: $transition-base;
    font-size: $tabs-font-size-min;
    padding: $spacer025 $spacer05 0;
    color: $grey-dark;

    @media (min-width: $bp-xs) {
      font-size: $tabs-font-size-xs;
    }

    @media (min-width: $bp-md) {
      font-size: $tabs-font-size;
      padding: $spacer025 $spacer075 0;
    }

    .tab-links__item--active &,
    &:hover,
    &:focus,
    &:active {
      background-color: $tabs-border-active;
      color: $grey-darker;
    }
  }
}
</style>